namespace app.support.alert {
    "use strict";    
    
    import Properties = app.support.constants.Properties;
    import MessagesService = app.support.messaging.MessagesService;
    
    export interface IAlert {
        identificador: string;
        type: string;
        name: string;
        content: { titulo: string, mensagem: string, informacao: string, observacao: string };
        receiver: string;
        sender: string;
        read: boolean;
        creationDate: Date;
        tenant: string;
    }
    
    export class AlertService {

        private modulosApi: string;
        
        /** @ngInject */
        public constructor($rootScope: ng.IRootScopeService,                 
                private $http: ng.IHttpService,
                private messagesService: MessagesService,
                private properties: Properties,
                private $q: ng.IQService
            ) {
                this.modulosApi = `${this.properties.apiUrl}/integracoes-modulos/api`;            
        }        
        
        public recuperarAlertasNaoLidos(): ng.IPromise<Array<IAlert>> {
            const url = `${this.modulosApi}/alerts`;
                return this.$http.get<Array<IAlert>>(url)
                    .then((response) => {
                        // @ts-ignore                        
                        return response.data;
                    });
        }

        public atualizarAlertasComoLidos(alertas: string[]): void {
            const url = `${this.modulosApi}/alerts`;

            this.$http.patch(url, alertas)
                .then(() => this.messagesService.success("Alerta(s) marcado(s) como ciente(s)!"))
                .catch(() => this.messagesService.error("Ocorreu um erro ao marcar o(s) alerta(s) como ciente(s)!"));
        }
        
    }
    
    angular
        .module("app.support.alert")
        .service("alertService", AlertService);
}
